import { jwtDecode } from 'jwt-decode';
import { generateUserAgentHeader, urls } from 'Utilities/dataHelpers';
import mediator from 'Utilities/mediator';
import { persistAuthSession } from 'Utilities/session';

export const signIn = async (
  email: string,
  password: string,
  osType: string,
  osVersion: string,
  app: App,
  appVersion: string,
  deviceId: string,
  _force = false
) => {
  const result = await mediator.request<ApiResponse<AuthResponse>>('api:invoke', {
    method: 'POST',
    url: `${urls.clmApiUrl}login`,
    headers: {
      'X-User-Agent': generateUserAgentHeader(app, appVersion, osType, osVersion),
      'X-Device-ID': deviceId,
    },
    data: {
      email,
      password,
    },
  });

  if (result.data) {
    if (result.data.tokenType !== 'MOCK') {
      const decodedToken = jwtDecode<{ id: string; did: string; exp: number; iat: number }>(
        result.data.accessToken
      );

      const authSession: AuthSession = {
        status: result.status,
        access_token: result.data.accessToken,
        token_type: result.data.tokenType,
        account_id: decodedToken.id,
        expires: decodedToken.exp,
        include: {
          patient: result.data.include.patient,
        },
      };

      persistAuthSession(authSession);

      return authSession;
    }

    // TODO: temporary while API is returning mocked access token
    // - skipped jwtDecode because the token is not valid

    const { firstName, lastName, email, language, country, dateOfBirth, domainData, phone } =
      result.data.include.patient;

    const mockedAuthSession: AuthSession = {
      access_token: result.data.accessToken,
      token_type: 'Bearer',
      account_id: '026145c3-e89f-4c72-b751-98773055106e',
      expires: 0,
      include: {
        patient: {
          firstName,
          lastName,
          email,
          phone,
          language,
          country,
          dateOfBirth,
        },
      },
    };

    if (!result.data.accessToken) {
      mockedAuthSession.status = result.status;
    }

    if (domainData) {
      mockedAuthSession.include.patient.domainData = domainData;
    }

    persistAuthSession(mockedAuthSession);

    return mockedAuthSession;
  }

  throw result;
};

export const forgotPass = async (
  email: string,
  osType: string,
  osVersion: string,
  app: string,
  appVersion: string
) => {
  const result = await mediator.request<ApiResponse<void>>('api:invoke', {
    method: 'POST',
    url: `${urls.apiUrl}password/forgot`,
    headers: {
      'X-User-Agent': generateUserAgentHeader(app, appVersion, osType, osVersion),
    },
    data: {
      email,
    },
  });

  if (result.data) {
    return result.data;
  }

  throw result;
};

export const resetPass = async (
  password: string,
  tokenID?: string,
  product?: string,
  version?: string
) => {
  const result = await mediator.request<ApiResponse<void>>('api:invoke', {
    method: 'POST',
    url: `${urls.apiUrl}password/reset`,
    headers: {
      'X-User-Agent': generateUserAgentHeader(product, version),
    },
    data: {
      password,
      tokenID,
    },
  });

  if (result.data) {
    return result.data;
  }

  throw result;
};
